// services/video.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IVideo } from "../videoModal";
import moment from "moment";

export const getAllVideos = createAsyncThunk("Video/FindAllVideo", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Video/FindAllVideo`,
      {
        Title: "",
      },
    );
    return response.data?.Data?.length > 0
      ? response.data.Data?.map((video: any) => ({
          ...video,
          Date: video.Date ? moment(video.Date).format("DD/MM/YYYY") : "-",
        }))
      : [];
  } catch (error: any) {
    console.error("Error Fetching Videos:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createVideo = createAsyncThunk(
  "Video/InsertVideo",
  async (videoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Video/InsertVideo`,
        videoData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Video:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateVideo = createAsyncThunk(
  "Video/UpdateVideo",
  async (videoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Video/UpdateVideo`,
        videoData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Video:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteVideo = createAsyncThunk(
  "Video/DeleteVideo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Video/DeleteVideo`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Video:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getVideoByID = createAsyncThunk(
  "Video/FindByIDVideo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Video/FindByIDVideo`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        VideoURL: result.VideoURL,
        Tagline: result.Tagline,
        Date: result.Date ? moment(result.Date, "YYYY-MM-DD").toDate() : null,
        ShortDescription: result.ShortDescription,
        SequenceNo: result.SequenceNo,
        IsDisplayHome: result.IsDisplayHome,
        ImageUpload: result.ImageUpload,
        IsActive: result.IsActive ? 1 : 2,
      } as IVideo;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Video:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveVideos = createAsyncThunk(
  "Video/FindAllActiveVideo",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Video/FindAllActiveVideo`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Videos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveVideo = createAsyncThunk(
  "Video/ActiveInActiveVideo",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Video/ActiveInActiveVideo`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Video:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
